var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _path24, _path25, _path26, _g3, _path27, _g4, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNikola(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_26",
    "data-name": "Groupe 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 274.934,
    height: 844,
    viewBox: "0 0 274.934 844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 274.934,
    height: 844,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 274.934,
    height: 843.998,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 138.759,
    height: 88.12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 43.919,
    height: 31.391,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 130.744,
    height: 147.778,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 3.815,
    height: 7.202,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 81.826,
    height: 184.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 73.172,
    height: 168.877,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_25",
    "data-name": "Groupe 25",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_24",
    "data-name": "Groupe 24",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_23",
    "data-name": "Groupe 23",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M99.691,1855.727l-.8-5.507s-7.811,15.532-15.718,13.979-28.663-12.567-28.663-13.979-1.542-.705-1.542-.705v7.308s17.5,14.859,30.345,13.165,16.379-14.261,16.379-14.261",
    transform: "translate(-29.389 -1026.125)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M98.846,1735.522s-4.191,15.487-16.158,15.487-29.766-11.93-29.8-16.425c-.018-2.569,1.815-21.668,2.84-32.128.4-4.053.671-6.806.671-6.806l.3-44.4,31.861-11.006v51.512l1.489,6.333a.014.014,0,0,0,0,.009Z",
    transform: "translate(-29.344 -910.108)",
    fill: "#e59977"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M52.882,1794.514c.037,4.494,17.836,16.424,29.8,16.424s16.156-15.485,16.156-15.485l-8.186-34.838s.063-4.948-1.193-5.056-6.058-4.49-6.058-4.49-5.365-6.778-21.178.7c0,0-1.975,4.8-2.824,5.086s-3.007-1.278-3.007-1.278l-.67,6.807-.1.995q-.078.771-.157,1.587l-.033.358c-1.047,10.749-2.575,26.842-2.556,29.186",
    transform: "translate(-29.342 -970.038)",
    fill: "#272d2f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M247.2,1648.343l-5.836,74.318h96.62l-63.348-43.3,4.1-33.708Z",
    transform: "translate(-133.922 -913.11)",
    fill: "#e59977"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M240.788,1770.307l106.174-.435a13.35,13.35,0,0,0-.124-3.777c-2.014-11.024-18.945-11.826-29.082-16.436-16.18-7.354-34.745-25.416-38.463-25.714s-11.942,7.209-10.7,8.489,5.579,4.669,5.579,4.669l-30.2-8.327-2.932,37.319Z",
    transform: "translate(-133.603 -956.544)",
    fill: "#272d2f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M240.788,1822.857l106.174-.435a13.35,13.35,0,0,0-.124-3.777H241.044Z",
    transform: "translate(-133.603 -1009.094)",
    fill: "#fafeff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M275.57,225.474c2.694-1.872,8.876-7.875,4.781-21.759l-9.025,22.848,2.106-.273a4.83,4.83,0,0,0,2.139-.816",
    transform: "translate(-150.548 -113.035)",
    fill: "#01121e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M204.71,63.058l-1.537,4.658-65.279,1.037-4.13-7.318-4.531-31.364c1.356-3.611,8.442-16.938,24.549-24.556A58.277,58.277,0,0,1,170.051.653c13.157-1.951,25.624.6,30.367,6.362,5.258,6.39,2.559,14.189,2.559,14.189s5.952-1.97,7.579,4.13c3.35,12.562-5.846,37.724-5.846,37.724",
    transform: "translate(-71.706 -0.005)",
    fill: "#01121e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M112.4,927.269l.307-23.125-2.546,22.448L110,927.95l-9.433,183.474-72.237-1.389,1.714-44.185,4.514-116.467,3.472-89.553,2.039-52.651,10.7-32.776L58.7,750.111,169.392,624.885,176.835,761l-.045,10.71-.236,58.919-.316,77.588,1.051,29.945,5.934,168.877-73.172-2.889.5-38.086v0Z",
    transform: "translate(-15.72 -346.725)",
    fill: "#404a4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(22.311 424.985)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_28",
    "data-name": "Trac\\xE9 28",
    d: "M188.881,954.725l-.236,58.919-63.74,13.439-2.573.543-72.211,15.219,2.039-52.651,10.7-32.776Z",
    transform: "translate(-50.122 -954.725)"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_29",
    "data-name": "Trac\\xE9 29",
    d: "M317.045,645.173c.159-.491,71.507-11.857,71.507-11.857l-2.82-32.8h-64Z",
    transform: "translate(-175.915 -333.204)",
    fill: "#aeedf4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_30",
    "data-name": "Trac\\xE9 30",
    d: "M189.613,606.763c-18.45,5.548-50.267,14-50.267,14L129.6,573.344,127.586,620.2C95.2,624.075,0,601.937,0,601.937,3.589,555,6.707,531.675,13.226,495.335c14.139-78.8,9.536-56.241,9.536-56.241l1.022-21.216L34.262,277.465l37.55-15.976,25.74-10.952,23.786,6.6,28.815,7.99,14.2,82.3,3.35,54.664Z",
    transform: "translate(0 -139.015)",
    fill: "#fafeff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_31",
    "data-name": "Trac\\xE9 31",
    d: "M314.589,283.3c8.65,2.686,11.251,11.6,13.392,24.242s-8.174,69.34-8.174,69.34L296.356,315.97Z",
    transform: "translate(-164.436 -157.196)",
    fill: "#fafeff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M214.081,257.132l1.372,85.862-48.308-82.656,23.15-9.8Z",
    transform: "translate(-92.742 -139.015)",
    fill: "#5b99d2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_33",
    "data-name": "Trac\\xE9 33",
    d: "M216.1,223.741l-1.906,30.047-14.089.195L177.1,220.252c3.214-5.485,3.4-16.36,2.772-25.966-.641-9.832-2.14-18.328-2.14-18.328l35.785,21.014c-1.011,14.726-.019,21.366,1.015,24.35.772,2.23,1.571,2.42,1.571,2.42",
    transform: "translate(-98.263 -97.634)",
    fill: "#e59977"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_34",
    "data-name": "Trac\\xE9 34",
    d: "M215.315,221.322c-16.825-7.909-29.912-21.632-34.661-27.036-.641-9.832-2.14-18.328-2.14-18.328L214.3,196.972c-1.011,14.725-.018,21.366,1.016,24.35",
    transform: "translate(-99.05 -97.634)",
    fill: "#d86956"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M203.32,113c-.5,5.5-.472,14.983-3.789,19.831a6.745,6.745,0,0,1-3.3,2.689c-6.512,2.31-42.617-7.6-48.4-28.489-.147-.512-.267-1.033-.373-1.558a20.728,20.728,0,0,1-14.124-11.747c-3.072-7.149,2.9-14.36,8.622-14.182-2.684-9.66-2.515-22.155,10.394-31.529,25.974-18.852,51.022,2.382,51.565,2.844l.009.009a11.5,11.5,0,0,1,4.745,7.745c3.383,17.147-4.723,47.465-5.346,54.387",
    transform: "translate(-73.516 -22.322)",
    fill: "#e59977"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M121.851,588.2S56.828,672.262,6.033,719.441c14.139-78.8,20.476-123.3,20.476-123.3L29.593,552.4Z",
    transform: "translate(-3.347 -306.504)",
    fill: "#aeedf4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_37",
    "data-name": "Trac\\xE9 37",
    d: "M300.164,588.225s4.876-8.961,2.032-22.639l-15.575,10.157Z",
    transform: "translate(-159.034 -313.823)",
    fill: "#aeedf4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_38",
    "data-name": "Trac\\xE9 38",
    d: "M348.163,460.735l-33.857-43.473a3.164,3.164,0,0,1,3.041-2.447L352.9,454.776Z",
    transform: "translate(-174.396 -230.166)",
    fill: "#272d2f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M260.366,529.089c.13-.554,14.242-12.078,14.242-12.078s5.1-11.269,7.967-12.713,10.022,0,10.022,0,6.483-1.429,10.213-1.754c5.574-.485,21.116,5.906,22.922,7.531s-14.265,12.64-14.265,12.64-3.661,9.052-4.623,10.153l-5.871-3.7s-11.935,14.265-21.467,8.351c0,0-25.641,21.894-26.183,22.413s7.044-30.846,7.044-30.846",
    transform: "translate(-140.543 -278.829)",
    fill: "#e59977"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M163.849,446.983S106.9,494.437,82.027,490.41s-29.97-34.859-38.71-96.249c-8.55-60.077,8.374-80.779,13.665-83.131,12.866,4.848,26.964,38.353,30.621,64.1.74,5.209,1.534,10.672,2.329,16.066v0c3.133,21.249,6.284,41.473,6.284,41.473l60.569-21.91c-5.937,18.8,7.064,36.221,7.064,36.221",
    transform: "translate(-22.719 -172.58)",
    fill: "#fafeff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M149.025,532.6l-12.9,4.514,6.618-45.987c3.133,21.249,6.284,41.473,6.284,41.473",
    transform: "translate(-75.529 -272.51)",
    fill: "#aeedf4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M156.864,268.37l9.005-3.831s15.845,19.4,30.607,32.668c0,0,8.183-21.471,5.581-35.79l7.691,2.133s-2.19,30.046-7.461,41.783l-10.306,1.09Z",
    transform: "translate(-87.037 -145.052)",
    fill: "#5b99d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10",
    transform: "translate(76.356 130.433)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    d: "M200.121,324.408a.453.453,0,0,1-.332-.145l-28.136-30.488a.452.452,0,0,1,.664-.612L200.3,323.484l9.821-1.039c1.621-3.714,3.112-9.569,4.435-17.41a.452.452,0,0,1,.891.15c-1.364,8.085-2.913,14.1-4.606,17.866a.452.452,0,0,1-.364.264l-10.306,1.09-.048,0",
    transform: "translate(-171.533 -293.018)"
  }))))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M282.247,268.032l12.419,24.342-16.014,2.683,18.407,3.411-23.1,52.747-1.372-85.862Z",
    transform: "translate(-151.246 -147.236)",
    fill: "#aeedf4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M150.289,272.555l-11.348,4.876-2.175,26.641h21.539L139.144,314,198.6,355.211Z",
    transform: "translate(-75.886 -151.232)",
    fill: "#aeedf4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M323.921,497.394l53.955-147.778h76.788L402,485.2Z",
    transform: "translate(-179.73 -193.99)",
    fill: "#234087"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_13",
    "data-name": "Groupe 13",
    transform: "translate(144.19 155.628)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12",
    "data-name": "Groupe 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11",
    "data-name": "Groupe 11",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M323.921,497.394,454.664,349.616,402,485.2Z",
    transform: "translate(-323.92 -349.618)"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M462.934,616.548s1.579,5.283,4.781,4.7c1.854-.336,22.7-15.283,23.961-20.773s.43-11.525-3.095-16.064-12-6.838-14.765-4.686,5.625,6.545,7.364,9.119a7.2,7.2,0,0,1,1.148,5.2s-13.422-14.643-16.914-13.152.967,9.3.967,9.3-2.577-3.17-4.617-1.887c-1.831,1.152,2.38,11.246,2.38,11.246s-3.123-4.92-5.284-3.328,4.072,20.317,4.072,20.317",
    transform: "translate(-254.351 -321.218)",
    fill: "#e59977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_16",
    "data-name": "Groupe 16",
    transform: "translate(105.805 152.988)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15",
    "data-name": "Groupe 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_14",
    "data-name": "Groupe 14",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    d: "M238.14,350.895a.451.451,0,0,1-.409-.641l2.912-6.3a.451.451,0,0,1,.819.379l-2.912,6.3a.451.451,0,0,1-.41.262",
    transform: "translate(-237.689 -343.692)"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_50",
    "data-name": "Trac\\xE9 50",
    d: "M140.18,142.406s1.444-7.093,5.507-6.526S150.834,144,150.834,144s-2.619.4-1.355,3.613,2.8,1.891,2.618,4.918-4.875.945-6.41-.568,4.334,1.608,4.785-.662c0,0-7.945-3.4-2.8-9.741,0,0,.717-3.461-2.612-4.079-2.162-.4-4.611,3.89-4.882,4.93",
    transform: "translate(-77.78 -75.379)",
    fill: "#d86956"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51",
    "data-name": "Trac\\xE9 51",
    d: "M273.484,178.928s-8.449,3.4-10.343,4.043,2.622,3.4,4.516,2.911,5.681-5.5,5.827-6.954",
    transform: "translate(-145.754 -99.282)",
    fill: "#d86956"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_52",
    "data-name": "Trac\\xE9 52",
    d: "M257.1,192.265s-.167,2.3-.691,5.205c-.884,4.929-2.79,11.588-6.64,11.588-8.469,0-11.421-6.686-12.428-12.049a29.22,29.22,0,0,1-.479-6.591c11.841,6.316,20.238,1.846,20.238,1.846",
    transform: "translate(-131.411 -105.658)",
    fill: "#89211b"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_53",
    "data-name": "Trac\\xE9 53",
    d: "M257.1,192.265s-.167,2.3-.691,5.205c-2.356.975-7.737,1.977-19.068-.46a29.22,29.22,0,0,1-.479-6.591c11.841,6.316,20.238,1.846,20.238,1.846",
    transform: "translate(-131.411 -105.658)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_54",
    "data-name": "Trac\\xE9 54",
    d: "M205.26,110.476s2.085-7.066,8.435-8.823,13.488,2.317,12.693,4.109-6.165-3.259-11.046-2.187-8.867,4.282-10.082,6.9",
    transform: "translate(-113.89 -56.167)",
    fill: "#01121e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_55",
    "data-name": "Trac\\xE9 55",
    d: "M228.659,128.926a.451.451,0,0,1-.439-.349c-.051-.217-1.336-5.337-7.892-5.972a6.511,6.511,0,0,0-6.094,2.681.451.451,0,0,1-.763-.482,7.4,7.4,0,0,1,6.944-3.1c7.218.7,8.67,6.608,8.684,6.667a.453.453,0,0,1-.338.542.474.474,0,0,1-.1.011",
    transform: "translate(-118.408 -67.508)",
    fill: "#35180c"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56",
    d: "M228.22,131.9c0,2.244-1.526,4.063-3.408,4.063s-3.408-1.819-3.408-4.063,1.525-4.063,3.408-4.063,3.408,1.819,3.408,4.063",
    transform: "translate(-122.848 -70.934)",
    fill: "#35180c"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57",
    "data-name": "Trac\\xE9 57",
    d: "M226.755,132.251a1.251,1.251,0,1,1-.756-1.762,1.367,1.367,0,0,1,.756,1.762",
    transform: "translate(-124.467 -72.38)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58",
    "data-name": "Trac\\xE9 58",
    d: "M286.383,111.218s-1.2-6.612-4.843-8.256-7.745,2.168-7.289,3.845,3.54-3.049,6.342-2.046a10.363,10.363,0,0,1,5.789,6.458",
    transform: "translate(-152.152 -56.908)",
    fill: "#01121e"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_59",
    "data-name": "Trac\\xE9 59",
    d: "M276.63,130.022a.527.527,0,0,1-.065,0,.452.452,0,0,1-.383-.511c.033-.229.848-5.618,5.135-6.3,2.868-.451,4.18,2.846,4.235,2.987a.452.452,0,0,1-.842.326c-.011-.028-1.1-2.76-3.251-2.421-3.626.573-4.375,5.482-4.382,5.532a.452.452,0,0,1-.446.387",
    transform: "translate(-153.24 -68.344)",
    fill: "#35180c"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_60",
    "data-name": "Trac\\xE9 60",
    d: "M281.2,132.812c0,2.1.876,3.8,1.957,3.8s1.957-1.7,1.957-3.8-.876-3.8-1.957-3.8-1.957,1.7-1.957,3.8",
    transform: "translate(-156.029 -71.585)",
    fill: "#35180c"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_61",
    "data-name": "Trac\\xE9 61",
    d: "M284.239,133.141c-.134.727-.547,1.167-.921.983s-.568-.922-.434-1.649.547-1.167.921-.983.568.922.434,1.649",
    transform: "translate(-156.938 -72.939)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_62",
    "data-name": "Trac\\xE9 62",
    d: "M218.829,50.508S190,41.737,171.691,48.653l-7.854,3.453s-6.579,22.254-4.892,30.655c0,0-10.627-9.091-10.965-10.719s0-32.5,0-32.5l25.809-7.591s19.736.506,20.411.844,24.628,17.712,24.628,17.712",
    transform: "translate(-82.025 -17.732)",
    fill: "#01121e"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_63",
    "data-name": "Trac\\xE9 63",
    d: "M218.645,191.575a6.745,6.745,0,0,1-3.3,2.689c-6.512,2.31-42.618-7.6-48.4-28.489l2.043-12.8.565-6.882,2.542,19.729c5.075,19.261,33.1,25.275,33.1,25.275s.895-1.785,8.778-2.867c3.695-.507,4.647,1.358,4.678,3.343",
    transform: "translate(-92.629 -81.064)",
    fill: "#01121e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19",
    transform: "translate(12.612 579.867)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_18",
    "data-name": "Groupe 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17",
    "data-name": "Groupe 17",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_64",
    "data-name": "Trac\\xE9 64",
    d: "M110.157,1302.665l-.156,1.358L100.569,1487.5l-72.237-1.389,1.714-44.185Z",
    transform: "translate(-28.331 -1302.665)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22",
    "data-name": "Groupe 22",
    transform: "translate(94.331 591.436)",
    opacity: 0.5,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21",
    "data-name": "Groupe 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_20",
    "data-name": "Groupe 20",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_65",
    "data-name": "Trac\\xE9 65",
    d: "M285.084,1497.532l-73.172-2.889.5-38.086v0l66.735-127.9Z",
    transform: "translate(-211.912 -1328.655)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNikola);
export default __webpack_public_path__ + "static/media/nikola.50bb0dab92b339031f169eaa5f3c8eba.svg";
export { ForwardRef as ReactComponent };